module.exports = __webpack_public_path__ + "img/tbs_logo_new_white.6e39b5f0.png";